import { render } from "./singletonComponent.vue?vue&type=template&id=c506ded8&scoped=true"
import script from "./singletonComponent.vue?vue&type=script&lang=js"
export * from "./singletonComponent.vue?vue&type=script&lang=js"

import "./singletonComponent.vue?vue&type=style&index=0&id=c506ded8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c506ded8"]])

export default __exports__